import React, { useContext } from 'react'
import { createRoot } from 'react-dom/client'
import styled from 'styled-components'

// Atomic
import { NotificationContext } from './NotificationProvider'
import { fadeOut } from './util'

import { ResponsiveSize } from '@/components/atomic/_enums'
import Text from '@/components/atomic/atoms/Text'
// Cell
import COLOR from '@/components/cell/designTokens/color'

const ToastContainer = styled.div`
  position: fixed;
  z-index: 1000;
  bottom: 76px;
  width: 100%;
  text-align: center;
  @media screen and (max-width: ${ResponsiveSize.MOBILE_MAX_WIDTH}px) {
    bottom: 50px;
  }
`

const Toast = styled.div`
  display: inline-block;
  width: 384px;
  padding: 16px 0;
  line-height: 0;
  background: #666666;
  border-radius: 8px;
  @media screen and (max-width: ${ResponsiveSize.MOBILE_MAX_WIDTH}px) {
    width: calc(100% - 32px);
  }
`

export function useToast(): { show: (message: string, time?: number) => void } {
  const context = useContext(NotificationContext)

  return {
    show(message: string, time = 3000) {
      if (context && context.notiContainer) {
        // 중복 생성을 위해 toastContainer 생성
        const toastContainer = document.createElement('div')
        context.notiContainer.appendChild(toastContainer)

        // notiContainer 안에 toastContainer 그리기
        const root = createRoot(toastContainer)
        root.render(
          <ToastContainer>
            <Toast>
              <Text type="title4" color={COLOR.white}>
                {message}
              </Text>
            </Toast>
          </ToastContainer>,
        )
        setTimeout(() => {
          fadeOut(toastContainer, 200, () => {
            root.unmount()
            toastContainer.remove()
          })
        }, time)
      }
    },
  }
}
